var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"placeholder":_vm.placeholder,"clearable":"","size":"mini"},on:{"change":_vm.handleChange},model:{value:(_vm.tValue),callback:function ($$v) {_vm.tValue=$$v},expression:"tValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }